const expiryYear = (expiry) => {
    return parseInt(expiry.split('/')[1]);
};
export default expiryYear;
//# sourceMappingURL=expiryYear.js.map